import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  benefitsAndDeliverables: PropTypes.string,
  bannerImageUrl: PropTypes.oneOfType([
    PropTypes.shape({
      full: PropTypes.string,
      thumbnail: PropTypes.string,
    }),
    PropTypes.string,
  ]),
  // price: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/types/ProductType.js